export default __webpack_public_path__ + "static/media/crowd.09f46f61.svg";